import { useState } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import InvoicePaymentDialog from './InvoicePaymentDialog';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';
import { deleteAccountingInvoicePayment } from '@/lib/api';
import { accountingError } from '@/lib/accounting';

export default function PaymentActions({ payment, permissions, methods, onChanged }) {
  const [editing, setEditing] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [busy, setBusy] = useState(false);
  const remove = async () => {
    setBusy(true);
    try {
      await deleteAccountingInvoicePayment(payment.transaction_ref);
      setDeleting(false);
      toast.success('Payment deleted.');
      await onChanged?.();
    } catch (err) {
      toast.error(accountingError(err, 'Payment could not be deleted.'));
    } finally { setBusy(false); }
  };
  return <>
    {permissions?.edit_invoice_payment && <Button type="button" variant="ghost" size="icon" aria-label="Edit payment" onClick={() => setEditing(true)}><Pencil className="size-4" /></Button>}
    {permissions?.delete_invoice_payment && <Button type="button" variant="ghost" size="icon" aria-label="Delete payment" onClick={() => setDeleting(true)}><Trash2 className="size-4 text-red-600" /></Button>}
    <InvoicePaymentDialog payment={payment} open={editing} onOpenChange={setEditing} methods={methods} onRecorded={onChanged} />
    <ConfirmDeleteDialog open={deleting} onOpenChange={setDeleting} title="Delete payment?" detail={`${payment.amount_display} · ${payment.payment_date || 'Date not recorded'} · ${payment.reference || payment.method || 'Manual payment'}`} consequence="This removes the saved payment and recalculates balances in Billing and Accounting." confirmLabel="Delete payment" busy={busy} onConfirm={remove} />
  </>;
}
